import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getConfig } from 'app/stores/editor/config';
export function useConfig(keys = undefined) {
    const configId = useSelector((state) => state.editor.config);
    const values = useMemo(() => {
        const config = getConfig(configId);
        if (!config || !keys) {
            return config;
        }
        return Object.keys(keys).reduce((accum, key) => {
            accum[key] = configGet(key, keys[key]);
            return accum;
        }, {});
    }, [configId, keys]);
    return values;
}
